import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    api_token: null
  },
  mutations: {
    token(state, token) {
      state.api_token = token
    },
    removeToken(state) {
      state.api_token = null
    }
  },
  actions: {

  }
})
